import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { C } from './FormKit';

export default function OperatorHome() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  // Each station normally has its own login that lands straight on its screen,
  // so operators never need links. An admin has access to all of them but no
  // way in except typing the URL — these cards are that way in, and are hidden
  // from plain operators, who would only hit a permission wall.
  const isAdmin = user?.role === 'ADMIN';
  const card = (label, sub, color, to) => (
    <button onClick={() => navigate(to)} style={{
      flex: 1, minWidth: 220, background: C.panel, border: `1px solid ${C.border}`,
      borderLeft: `3px solid ${color}`, borderRadius: 14, padding: '32px 26px',
      cursor: 'pointer', textAlign: 'left', color: C.text,
    }}>
      <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 13, color: C.muted }}>{sub}</div>
    </button>
  );

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: C.sans }}>
      <div style={{ maxWidth: 680, margin: '0 auto', padding: '60px 22px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
          <div style={{
            fontFamily: C.mono, fontSize: 13, letterSpacing: '0.16em',
            textTransform: 'uppercase', color: C.muted,
          }}>BSC Gate · Operator station</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 12, color: C.faint }}>{user?.fullName}</span>
            <button onClick={logout} style={{
              padding: '8px 14px', borderRadius: 8, border: `1px solid ${C.border}`,
              background: '#fff', color: C.muted, fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}>Sign out</button>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
          {card('Entry form', 'Log a vehicle into the site', C.green, '/entry')}
          {card('Exit form', 'Log out & tag the load photo', C.teal, '/exit')}
          {card('Update', 'Correct a vehicle that is inside', C.amber, '/update')}
          {card('Charity vehicle', 'Stone given away — no weighing or billing', '#5B21B6', '/charity-vehicle')}
        </div>
        <p style={{ color: C.faint, fontSize: 12, marginTop: 30, fontFamily: C.mono }}>
          Keep one vehicle at the gate at a time. Submit the form before the next vehicle moves.
        </p>

        {isAdmin && (
          <div style={{ marginTop: 34, borderTop: `1px solid ${C.border}`, paddingTop: 26 }}>
            <div style={{
              fontFamily: C.mono, fontSize: 11, letterSpacing: '0.14em',
              textTransform: 'uppercase', color: C.muted, marginBottom: 16,
            }}>Other stations · admin access</div>
            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
              {card('Weighbridge', 'Tare & gross weight, corrections', C.teal, '/weighbridge')}
              {card('Challan', 'Record the government permit', '#5B21B6', '/challan')}
              {card('Payment', 'Take payment, adjust the amount', '#9D174D', '/payment')}
              {card('Material prices', 'Rate per tonne by material', C.amber, '/material-prices')}
              {card('Reject vehicle', 'Turn a vehicle away, with a reason', C.red, '/reject-vehicle')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}